import {
    AppRemoveButtonPopup,
    FlexBox,
    AppTable,
    FlexRow,
    AppEditButton,
} from 'components'
import React, { useMemo } from 'react'
import { useTabletAndBelowMediaQuery } from 'layout'
import { Card } from 'semantic-ui-react'

const ActionBoxes = ({ onEdit, onRemove }) => (
    <>
        <AppEditButton onClick={onEdit} type="button" />
        <AppRemoveButtonPopup onConfirm={onRemove} />
    </>
)

const CustomFieldCard = ({ item, onEdit, onRemove }) => (
    <Card fluid>
        <Card.Content>
            <Card.Header>{item.fieldName}</Card.Header>
            <Card.Description>
                <FlexRow>
                    <Card.Meta>Type:</Card.Meta>&nbsp; {item.fieldType}
                </FlexRow>
                {item.entityType && (
                    <FlexRow>
                        <Card.Meta>Entity:</Card.Meta>&nbsp; {item.entityType}
                    </FlexRow>
                )}
                {item.description && (
                    <FlexRow>
                        <Card.Meta>Description:</Card.Meta>&nbsp; {item.description}
                    </FlexRow>
                )}
                <FlexBox className="justify-content-end mt-2">
                    <ActionBoxes
                        onEdit={() => onEdit(item)}
                        onRemove={() => onRemove(item.id)}
                    />
                </FlexBox>
            </Card.Description>
        </Card.Content>
    </Card>
)

export const CustomFieldList = ({
    data,
    filter,
    pageChanged,
    totalCount,
    onEdit,
    onRemove,
}) => {
    const isMobile = useTabletAndBelowMediaQuery()

    const columns = useMemo(
        () => [
            {
                title: 'Field Name',
                key: 'fieldName',
                textAlign: 'left',
            },
            {
                title: 'Type',
                key: 'fieldType',
                textAlign: 'left',
            },
            {
                title: 'Entity',
                key: 'entityType',
                textAlign: 'left',
                render: item => item.entityType || 'N/A',
            },
            {
                title: 'Required',
                key: 'required',
                textAlign: 'center',
                render: item => (item.required ? 'Yes' : 'No'),
            },
            {
                title: 'Actions',
                key: 'actions',
                textAlign: 'center',
                width: isMobile ? 'auto' : 150,
                render: item => (
                    <FlexBox className="justify-content-center">
                        <ActionBoxes
                            onEdit={() => onEdit(item)}
                            onRemove={() => onRemove(item.id)}
                        />
                    </FlexBox>
                ),
            },
        ],
        [isMobile, onEdit, onRemove],
    )

    return (
        <AppTable
            data={data}
            columns={columns}
            pageChanged={pageChanged}
            filter={filter}
            totalCount={totalCount}
            mobileCard={<CustomFieldCard onEdit={onEdit} onRemove={onRemove} />}
        />
    )
}
